<template>
  <div>
    <v-skeleton-loader v-if="!data_loaded" type="table"></v-skeleton-loader>
    <v-card v-if="data_loaded">
      <v-card-title>
        <h1 class="ms-3">מעקב תזרימי כספי</h1>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-data-table
          class="text-center"
          :headers="headers"
          :items="items"
          mobile-breakpoint="0"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:[`item.amount`]="{ item }">
            <v-chip
              :color="item.amount > 0 ? 'green' : 'red'"
              class="font-weight-bold"
              :class="[
                { 'black--text': item.amount > 0 },
                { 'white--text': item.amount < 0 },
              ]"
              x-small
            >
              {{ item.amount }} ₪
            </v-chip>
          </template>
          <template v-slot:[`item.order_num`]="{ item }">
            <p
              class="text-center mx-auto"
              style="white-space: pre-wrap; max-width: 250px"
            >
              {{ item.order_num || "__" }}
            </p>
          </template>
          <template v-slot:[`item.description`]="{ item }">
            <p
              class="text-center mx-auto"
              style="white-space: pre-wrap; max-width: 250px"
            >
              {{ item.description || "__" }}
            </p>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-pagination
      class="mt-4"
      v-if="data_loaded"
      @input="change_page($event)"
      v-model="page"
      total-visible="7"
      :length="total"
      circle
    ></v-pagination>
  </div>
</template>

<script>
export default {
  name: "Table",
  props: ["data_loaded", "items", "page", "total"],
  data() {
    return {
      delete_obj: {
        delete_prop: false,
        delete_url: "coupons",
        title: "מחיקת קטגוריה",
        id: null,
      },
      headers: [
        {
          value: "date",
          text: "תאריך הוספה",
          align: "center",
        },
        {
          value: "amount",
          text: "סכום",
          align: "center",
        },
        {
          value: "old_balance",
          text: " מתאריך",
          align: "center",
        },
        {
          value: "order_num",
          text: "מספר הזמנה",
          align: "center",
        },
        {
          value: "description",
          text: "עד תאריך",
          align: "center",
        },
      ],
    };
  },
  methods: {
    change_page(page) {
      this.$emit("updatePage", page);
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.basic {
  .col {
    flex: 0 0 20%;
    max-width: 20%;
    @media (max-width: 991px) {
      flex: 0 0 50%;
      max-width: 50%;
    }
  }
}
</style>
